// import api from '@/price'
import { resolveResponseData } from '@/services/helpers'
import { endpoints } from 'endpoint'
import api from '@/axios'
import qs from 'qs'
const PRICE_API_URL =
    'https://api.coinstore.com/api/v1/market/trade/dcmusdt?size=5'
const DCM_PRICE_ID = 'dcm' as string

const WEEK_PRICE_API_URL =
    'https://api.coinstore.com/api/v1/market/kline/dcmusdt?size=6&period=1day'
export interface PriceParams {
    ids: string[]
    vs_currencies: string[]
    category?: string
    order?: string
    per_page?: number
    page?: number
    sparkline?: boolean
    price_change_percentage?: string
}

export function getPrices(params?: PriceParams) {
    return api
        .get(`${PRICE_API_URL}`, {
            params,
            paramsSerializer: (params) =>
                qs.stringify(params, { arrayFormat: 'comma', encode: false }),
        })
        .then((res) => {
            res.data[DCM_PRICE_ID] = {
                usd: res.data.data[0].price,
                eur: 1.0,
            }
            return resolveResponseData(res)
        })
}

export function getWeeklyPrices(params?: PriceParams) {
    return api.get(`${WEEK_PRICE_API_URL}`).then((res) => {
        return res.data.data.item
    })
}
